import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'

const hasAzubisSelector = state => state.authentication.permissions.meineAzubis.hasAzubis
const allAzubisSelector = state => state.azubis.azubisWithAusbildungsplanModul
const loadingSelector = state => state.azubis.loading.getAzubisWithAusbildungsplanModul

export function useAzubisWithAusbildungsplanModul() {
  const hasAzubis = useSelector(hasAzubisSelector)
  const allAzubis = useSelector(allAzubisSelector, shallowEqual) || []

  useEffect(() => {
    if (hasAzubis) {
      actions.azubis.getAzubisWithAusbildungsplanModul()
    }
  }, [hasAzubis])

  const loading = useSelector(loadingSelector)

  return {
    allAzubis,
    loading,
  }
}
